import { render } from "./MenuItem.vue?vue&type=template&id=5bec9574&scoped=true"
import script from "./MenuItem.vue?vue&type=script&lang=js"
export * from "./MenuItem.vue?vue&type=script&lang=js"

import "./MenuItem.vue?vue&type=style&index=0&id=5bec9574&lang=scss&scoped=true"
import "./MenuItem.vue?vue&type=style&index=1&id=5bec9574&lang=scss"

import exportComponent from "/data/devops/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bec9574"]])

export default __exports__